<template>
    <div v-if="value" class="drawMultiResultModal">
        <ResultModal v-model="value" v-bind="drawResult" @close="close">
            <template #cover>
                <PrizeList :list="drawResult.coverList" />
            </template>
        </ResultModal>
    </div>
</template>

<script>
import ResultModal from '../ResultModal/index.vue';
import PrizeList from '../PrizeList/index.vue';

export default {
    name: 'multiDrawResultModal',
    components: {
        ResultModal,
        PrizeList
    },
    props: {
        value: {
            required: true,
            type: Boolean,
            default: false
        },
        drawResult: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {};
    },
    methods: {
        close() {
            this.$emit('input', false);
        }
    }
};
</script>

<style lang="less" scoped>
.drawMultiResultModal {
}
</style>
